<template>
    <div class="footer-section col-12 float-l border-top-edeeef pt_18 pb_20">
        <div class="container">
            <div class="row">
                <p class="left-footer-section float-l left color-888888 font-text-regular-benton heading-text-12 line-height-16 mb_0"> Signed in {{sessionCount}} Devices </p>
                <p class="right-footer-section float-r right font-benton-medium heading-text-12 line-height-16 mb_0"> <a href="javascript:void(0)" class="color-f5911e" v-on:click="deleteSession()"> Delete all Session </a> </p>
            </div>
        </div>
        <div class="loading-container" style="display: none;">
            <div class="loading">
                <img src="/static/images/loading.gif">
            </div>
        </div>
    </div>
</template>

<script>

    import EventBus from ".././event-bus";
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common';

    export default {
        name: "Footer",
        mixins: [commonMixins],
        data: () => ({
            sessionCount: 0
            }),
        created: function () {

        },
        mounted: function () {
            var self = this;
            /**Search bar**/
            /* $(document).ready(function(){
                var submitIcon = $('.searchbox-icon');
                var inputBox = $('.searchbox-input');
                var searchBox = $('.searchbox');
                var isOpen = false;
                submitIcon.click(function(){
                    if(isOpen == false){
                        searchBox.addClass('searchbox-open');
                        inputBox.focus();
                        isOpen = true;
                    } else {
                        searchBox.removeClass('searchbox-open');
                        inputBox.focusout();
                        isOpen = false;
                    }
                });  
                submitIcon.mouseup(function(){
                    return false;
                });
                searchBox.mouseup(function(){
                    return false;
                });
                $(document).mouseup(function(){
                    if(isOpen == true){
                        $('.searchbox-icon').css('display','block');
                        submitIcon.click();
                    }
                });
            }); */

            //check user loggged in or not
            var userObj = localStorage.getItem("user_obj");
            var roleName = localStorage.getItem("role");


            //if user logged in than remove login button and registration button
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", true, userJson["name"], userJson["email"], userJson["id"], roleName);
            }
            self.loadSession();

        },
        methods: {
            loadSession: function() {

                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.get("get-sessions", config)
                        .then(function (data) {
                            if (data.data.code == 200 && data.data.status == 'success') {
                                self.sessionCount = data.data.content;
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        })
            },
            deleteSession: function() {
                var self = this;

                var fields = {
                    token: localStorage.getItem("tkn")
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                //self.showLoader();
                HTTP.post("delete-sessions", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            self.loadSession();
                        }
                        //self.hideLoader();
                    })
                    .catch(function (err) {
                        //self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/partials/Footer.vue